import { styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

interface ContentItemTitleProps {
  color?: string;
}

export const ContentItemTitle = styled("span")(({ color }: ContentItemTitleProps) => ({
  color,
  fontFamily: "Manrope",
  fontSize: "12px",
  fontWeight: 600,
  lineHeight: "16px",
  letterSpacing: "0.5px",
  whiteSpace: "nowrap",
}));

export const ContentItemText = styled("span")(() => ({
  color: colors.gray600,
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.5px",
  whiteSpace: "nowrap",
}));

export const ContentItemTextBold = styled("span")(() => ({
  color: colors.gray500,
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 700,
  lineHeight: "20px",
  letterSpacing: "0.5px",
  whiteSpace: "nowrap",
}));

export const ContentItemContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  paddingTop: "15px",
}));

interface StepLocationProps {
  color: string;
}

export const StepLocation = styled("span")(({ color }: StepLocationProps) => ({
  color: `${color} !important`,
  fontFamily: "Manrope",
  fontSize: "16px",
  fontWeight: 700,
  lineHeight: "24px",
  letterSpacing: "0.15px",
  whiteSpace: "nowrap",
}));
